import * as Yup from 'yup';
import { AsYouType, isValidPhoneNumber } from 'libphonenumber-js';

export const postalCodeRegExp =
  /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})|[A-Z]{1,2}\d{1,2}(?:\s?\d?[A-Z]{0,2})?$/;

export const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const phoneRegExp = /^\+?[1-9]\d{7,14}$/;

export const getValidationSchema = () =>
  Yup.object({
    email: Yup.string().matches(emailRegExp, 'Invalid email address').required('Enter your email address'),
    isUkTaxPayer: Yup.boolean(),
    address: Yup.string().when('isUkTaxPayer', {
      is: value => value === true,
      then: schema => schema.required('Enter your home address'),
      otherwise: schema => schema,
    }),
    city: Yup.string().when('isUkTaxPayer', {
      is: value => value === true,
      then: schema => schema.required('Enter your city'),
      otherwise: schema => schema,
    }),
    postal_code: Yup.string().when('isUkTaxPayer', {
      is: value => value === true,
      then: schema => schema.matches(postalCodeRegExp, 'Invalid postal code').required('Enter your postal code'),
      otherwise: schema => schema,
    }),
  });

export const handleOnPaste = (event, setPastedValue) => {
  const pastedData = event.clipboardData.getData('Text');
  setPastedValue(pastedData);
};

export const handlePhoneValidation = (value, country, setFieldValue, setIsPhoneValid, setUserInfo, setPastedValue, setPhoneError) => {
  // Ensure the input value has the '+' prefix
  let inputValue = value.startsWith('+') ? value : `+${value}`;

  // Create an instance of AsYouType to format the phone number
  const asYouType = new AsYouType(country.countryCode);
  let formattedPhone = asYouType.input(inputValue);

  if (country.dialCode === '44' && formattedPhone.startsWith('+44 0')) {
    formattedPhone = `+44 ${formattedPhone.slice(5)}`;
  }

  // Check if the phone number is valid
  const isValid = country.dialCode === '225' ? true : isValidPhoneNumber(formattedPhone, country.countryCode);

  setIsPhoneValid(isValid);
  if (isValid) {
    // If the country is UK and the phone starts with zero after country code, remove it
    setUserInfo(prevState => ({
      ...prevState,
      phone: formattedPhone,
      phone_country_code: country.dialCode,
    }));
    setFieldValue('phone', formattedPhone);
    setPastedValue('');
    setPhoneError('');
  } else {
    setUserInfo(prevState => ({
      ...prevState,
      phone: formattedPhone,
      phone_country_code: country.dialCode,
    }));
    setFieldValue('phone', formattedPhone);
    setPastedValue('');
    setPhoneError('Invalid phone number. Please check and try again.');
  }
};
